import React from 'react';
import config from "../../config";

const ColorIndicator = ({currentStatus,indicatorMap, style = {}}) => {

    const defaultIndicatorColorsMap = {
        [config.currentStatusMap.offline]: '#A4ADC1',
        [config.currentStatusMap.available]: '#00E3A6',
        [config.currentStatusMap.notHere]: '#E14E52',
        [config.currentStatusMap.pause]: '#e1984e',
    };

    return (
        <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: indicatorMap ? indicatorMap[currentStatus] : defaultIndicatorColorsMap[currentStatus || config.currentStatusMap.offline],
            ...style,
        }}/>);
};

export default ColorIndicator;


// WEBPACK FOOTER //
// ./src/components-new/general/ColorIndicator.jsx